// Copyright (c) StrangeBee 2023

import React, { ReactElement, ReactNode } from 'react';
import { classList } from '@Helpers/className';
import { THButton } from '@Molecules/Inputs/THButton/THButton';

import './LinkButton.scss';

interface LinkButtonProps {
    onClick: (...arg: any[]) => void;
    children: ReactNode;
    className?: string;
}

const LinkButton = ({ onClick, children, className }: LinkButtonProps): ReactElement => (
    <THButton type="link" onClick={onClick} className={classList('link-button', className)}>
        {children}
    </THButton>
);

export default LinkButton;
